/**
 * 以下 symbol 均用于在 shell 层对外暴露的模型中存储相应内部模型的 key
 */
export var projectSymbol = Symbol('project');
export var designerSymbol = Symbol('designer');
export var skeletonSymbol = Symbol('skeleton');
export var documentSymbol = Symbol('document');
export var editorSymbol = Symbol('editor');
export var nodeSymbol = Symbol('node');
export var modalNodesManagerSymbol = Symbol('modalNodesManager');
export var nodeChildrenSymbol = Symbol('nodeChildren');
export var propSymbol = Symbol('prop');
export var settingFieldSymbol = Symbol('settingField');
export var settingTopEntrySymbol = Symbol('settingTopEntry');
export var propsSymbol = Symbol('props');
export var detectingSymbol = Symbol('detecting');
export var selectionSymbol = Symbol('selection');
export var historySymbol = Symbol('history');
export var canvasSymbol = Symbol('canvas');
export var dragonSymbol = Symbol('dragon');
export var componentMetaSymbol = Symbol('componentMeta');
export var dropLocationSymbol = Symbol('dropLocation');
export var simulatorHostSymbol = Symbol('simulatorHost');
export var simulatorRenderSymbol = Symbol('simulatorRender');
export var dragObjectSymbol = Symbol('dragObject');
export var locateEventSymbol = Symbol('locateEvent');
export var designerCabinSymbol = Symbol('designerCabin');
export var editorCabinSymbol = Symbol('editorCabin');
export var skeletonCabinSymbol = Symbol('skeletonCabin');
export var hotkeySymbol = Symbol('hotkey');
export var pluginsSymbol = Symbol('plugins');
export var workspaceSymbol = Symbol('workspace');
export var windowSymbol = Symbol('window');
export var pluginInstanceSymbol = Symbol('plugin-instance');
export var resourceTypeSymbol = Symbol('resourceType');
export var resourceSymbol = Symbol('resource');
export var clipboardSymbol = Symbol('clipboard');
export var configSymbol = Symbol('configSymbol');
export var conditionGroupSymbol = Symbol('conditionGroup');
export var editorViewSymbol = Symbol('editorView');
export var pluginContextSymbol = Symbol('pluginContext');
export var skeletonItemSymbol = Symbol('skeletonItem');
export var commandSymbol = Symbol('command');